import { StorageService } from '../../service/storage/storage.service';
import { TrackingService } from '../../service/tracking/tracking.service';
import { CommonService } from './../../service/common/common.service';
import {
    Component,
    OnInit,
    OnChanges,
    Renderer2,
    OnDestroy,
    HostListener,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import { FilterService } from '../../service';
import {
    NavigationService,
    INavigationData,
    AuthService,
    UserDetails,
    UserTypes,
    ShipmentService,
} from '../../service';
import { SubSink } from 'subsink';
import {
    IFiltersCriteria,
    SelectedFilters,
    ISelectedFilters,
} from '../../lib/types/selectedFilters';
import { MenuItem, MessageService } from 'primeng/api';
// Corrected import path for BdpServiceCode
import { BdpServiceCode } from '../../lib/model/common';
import { Router } from '@angular/router';
import { ExceptionService } from '../../service/exception/exception.service';
import moment from 'moment';
import { AirAppRoutes } from '../../lib/air-api-constant';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserControlService } from '../../service/userControl/user-control.service';

@Component({
    selector: 'app-content-header',
    templateUrl: './content-header.component.html',
    styleUrls: ['./content-header.component.scss'],
    standalone: false
})
export class ContentHeaderComponent implements OnInit, OnChanges, OnDestroy {
    @Input() navData: any = {};
    @Output() onExceptionFilterSubmit = new EventEmitter();
    @Output() onClear = new EventEmitter();
    showExport: boolean = false;
    display: boolean = false;
    showSearchList: any;
    openAlertSubscriptionDialog: boolean = false;
    startDateActive = false;
    endDateActive = false;
    breadcrumbs: MenuItem[] = [
        {
            label: 'Home',
            routerLink: [
                this.commonService.getRoute({
                    route: AirAppRoutes.User.HOME,
                    type: 'User',
                }),
            ],
        },
    ];
    home!: MenuItem;
    private subscription = new SubSink();
    public currentNav!: INavigationData;
    public filters: IFiltersCriteria | undefined;
    public pageMilestone: number = 0;
    private userDetails!: UserDetails;
    public showFilterActive: boolean = false;
    public globalSearchValue: string = '';
    public searchCriteria: any = {
        name: 'BDP Reference No.',
        code: 'bdpReferenceNumber',
        id: '1',
    };
    public startDate!: any;
    public endDate!: any;
    public AirAppRoutes: any = AirAppRoutes;
    hideFilterFor: Array<string> = [
        AirAppRoutes.User.HOME,
        AirAppRoutes.User.TRACKING_LIST,
        AirAppRoutes.User.FAVORITE,
    ];
    public selectButton: { viewData: boolean; viewHistory: boolean } = {
        viewData: false,
        viewHistory: false,
    };
    pageCtrl: any = {
        visible: false,
        globalSearch: false,
        filter: false,
        export: false,
        email: false,
        history: false,
        data: false,
    };
    public downloadList: any = [
        { key: 1, value: 'Last 30 days' },
        { key: 3, value: 'Last 3 months' },
        { key: 6, value: 'Last 6 months' },
        { key: 12, value: 'Last 12 months' },
        { key: 0, value: 'Custom Period' },
    ];

    bdpServiceCode: any = [];
    private filterSelection!: ISelectedFilters;
    selectedGlobalFilter: any;
    exportVisibility: boolean = false;
    customPeriodListVisibility: boolean = false;
    isTranshipment!: number;
    isHazardous!: string;
    companies: any;
    exceptionCategories: any[] = [];
    countryRegion: any[] = [];
    exceptionTimeframes: any[] = [];
    exceptionSourceTypes: any[] = [];
    exceptionFilterFrom: any;
    submitBtnDisabled: boolean = true;
    hasCompany: boolean = false;
    isFilterSelected: boolean = false;
    private hasReloaded: boolean = false;
    @HostListener('window:click', ['$event'])
    handleKeyDown(event: any) {
        const exportElem = document.getElementById('exportList');
        const exportElemIcon = document.getElementById('exportIcon');
        if (exportElem) {
            if (
                exportElem.contains(event.target) ||
                (exportElemIcon && exportElemIcon.contains(event.target))
            ) {
                // Clicked in box
            } else {
                this.exportVisibility = false;
            }
        }
    }

    constructor(
        public renderer: Renderer2,
        private shipmentService: ShipmentService,
        private filterService: FilterService,
        private authService: AuthService,
        private navigationService: NavigationService,
        private messageService: MessageService,
        public router: Router,
        private commonService: CommonService,
        private exceptionService: ExceptionService,
        private trackingService: TrackingService,
        private formBuilder: FormBuilder,
        private storageService: StorageService,
        private userControlService: UserControlService
    ) {
        this.renderer.listen('body', 'click', () => {
            if (this.showExport) {
                this.showExport = false;
            }
        });
        this.exceptionFilterFrom = this.formBuilder.group({
            category: ['', [Validators.required]],
            timeframe: ['', [Validators.required]],
            source: [[], [Validators.required]],
            originregion: [[], [Validators.required]],
            destinatinregion: [[], [Validators.required]],
            ServiceCode: ['', [Validators.required]],
        });
        this.subscription.add(
            this.authService.$user.subscribe((userDetails: UserDetails) => {
                if (userDetails) {
                    this.userDetails = userDetails;
                }
            }),
            // this.userControlService.$userCompany.subscribe((companies: any) => {
            //     if (companies && companies.length) {
            //         this.hasCompany = true;
            //     }
            // }),
            this.trackingService.$isTransshipmentSubject.subscribe((res) => {
                this.isTranshipment = res;
            }),
            // this.trackingService.$isHazardousSubject.subscribe((res) => {
            //     this.isHazardous = res;
            // }),
            this.filterService.$filterSelection.subscribe((filter) => {
                if (filter) {
                    const filterSelected: IFiltersCriteria =
                        this.filterService.getIds(filter);
                    this.selectedGlobalFilter = JSON.parse(
                        JSON.stringify(filterSelected)
                    );
                } else {
                    const filterSelected: IFiltersCriteria =
                        this.filterService.getIds(this.filterSelection);
                    this.selectedGlobalFilter = JSON.parse(
                        JSON.stringify(filterSelected)
                    );
                }
                //To get the selected companies in the download payload.
                if (filter?.companies) {
                    if (Array.isArray(filter.companies))
                        this.companies = filter.companies[0];
                    else this.companies = filter.companies;
                }
            }),
            this.filterService.filterSelectionDownloadOption.subscribe(
                (state) => {
                    if (state == null || state == undefined) {
                        this.showFilterActive = false;
                    } else {
                        this.showFilterActive = true;
                    }
                }
            ),
            this.navigationService.$currentNav.subscribe(
                (selectedNav: INavigationData) => {
                  
                    if (selectedNav) {
                        const tempCtrl = {
                            visible: true,
                            globalSearch: false,
                            filter: false,
                            export: false,
                            email: false,
                            exceptionCardFilters: false,
                            exceptionDateFilter: false,
                            history: false,
                            data: false,
                        };
                        this.currentNav = selectedNav;
                  
                        switch (this.currentNav.routeType) {
                            case AirAppRoutes.User.HOME: {
                                // if (this.hasCompany) { // TODO: add this condition from the companies api
                                tempCtrl.globalSearch = true;
                                tempCtrl.filter = true;
                                // }
                                this.breadcrumbs = [{ label: 'Home' }];
                                break;
                            }
                            case AirAppRoutes.User.TRACKING_LIST: {
                                tempCtrl.globalSearch = true;
                                tempCtrl.filter = true;
                                this.breadcrumbs = [{ label: 'Tracking List' }];
                                break;
                            }
                            case AirAppRoutes.User.TRACKING_LIST_DETAILS: {
                                tempCtrl.globalSearch = true;
                              //  tempCtrl.globalSearch = true;
                                this.breadcrumbs = [
                                    {
                                        label: 'Tracking List',
                                        routerLink: [
                                            this.commonService.getRoute({
                                                route: AirAppRoutes.User
                                                    .TRACKING_LIST,
                                                type: 'User',
                                            }),
                                        ],
                                    },
                                    { label: 'Tracking Details' },
                                    { label: '' },
                                ];
                                break;
                            }
                            case AirAppRoutes.User.TRACKING_LIST_DETAILS_HOME: {
                                tempCtrl.globalSearch = true;
                             //   tempCtrl.globalSearch = true;
                                this.breadcrumbs = [
                                    {
                                        label: 'Home',
                                        routerLink: [
                                            this.commonService.getRoute({
                                                route: AirAppRoutes.User.HOME,
                                                type: 'User',
                                            }),
                                        ],
                                    },
                                    { label: 'Tracking Details' },
                                    { label: '' },
                                ];
                                break;
                            }

                            case AirAppRoutes.User.ETA_THRESHOLD: {
                                this.breadcrumbs = [
                                    {
                                        label: 'Home',
                                        routerLink: [
                                            this.commonService.getRoute({
                                                route: AirAppRoutes.User.HOME,
                                                type: 'User',
                                            }),
                                        ],
                                    },
                                    { label: 'ETA Settings' },
                                ];
                                break;
                            }
                            case AirAppRoutes.User.FLIGHT_EQUIVALENCY_MANAGER: {
                                tempCtrl.globalSearch = false;
                                tempCtrl.filter = false;
                                this.breadcrumbs = [{ label: 'Flight Equivalency Manager' }];
                                break;
                            }
                            // case AirAppRoutes.User.INTRANSIT_ALERTS: {
                            //     this.breadcrumbs = [
                            //         {
                            //             label: 'Home',
                            //             routerLink: [
                            //                 this.commonService.getRoute({
                            //                     route: AirAppRoutes.User.HOME,
                            //                     type: 'User',
                            //                 }),
                            //             ],
                            //         },
                            //         { label: 'Alerts' },
                            //     ];
                            //     tempCtrl.globalSearch = false;
                            //     tempCtrl.filter = false;
                            //     break;
                            // }
                            // case AirAppRoutes.User.CHANGE_PASSWORD: {
                            //     this.breadcrumbs = [
                            //         {
                            //             label: 'Home',
                            //             routerLink: [
                            //                 this.commonService.getRoute({
                            //                     route: AirAppRoutes.User.HOME,
                            //                     type: 'User',
                            //                 }),
                            //             ],
                            //         },
                            //         { label: 'Change Password' },
                            //     ];
                            //     break;
                            // }
                            // case AirAppRoutes.User.PROFILE: {
                            //     this.breadcrumbs = [
                            //         {
                            //             label: 'Home',
                            //             routerLink: [
                            //                 this.commonService.getRoute({
                            //                     route: AirAppRoutes.User.HOME,
                            //                     type: 'User',
                            //                 }),
                            //             ],
                            //         },
                            //         { label: 'My Account' },
                            //     ];
                            //     break;
                            // }
                            // case AirAppRoutes.User.OVERVIEW: {
                            //     this.breadcrumbs = [
                            //         {
                            //             label: 'Home',
                            //             routerLink: [
                            //                 this.commonService.getRoute({
                            //                     route: AirAppRoutes.User.HOME,
                            //                     type: 'User',
                            //                 }),
                            //             ],
                            //         },
                            //         { label: 'My Account' },
                            //     ];
                            //     break;
                            // }
                            case AirAppRoutes.User.HELP: {
                                this.breadcrumbs = [{ label: 'Help' }];
                                break;
                            }
                            case AirAppRoutes.Manager.EXCEPTION: {
                                this.breadcrumbs = [
                                    { label: 'Exception Manager' },
                                ];
                                tempCtrl.export = true;
                                tempCtrl.email = true;
                                tempCtrl.exceptionCardFilters = true;
                                tempCtrl.exceptionDateFilter = true;
                                this.loadExceptionFilterOptions();
                                break;
                            }
                            // case AirAppRoutes.Manager.USER_CONTROL: {
                            //     this.breadcrumbs = [
                            //         { label: 'User Management' },
                            //     ];
                            //     tempCtrl.export = false;
                            //     break;
                            // }
                            // case AirAppRoutes.Manager.ASSIGN: {
                            //     this.breadcrumbs = [
                            //         {
                            //             label: 'User Management', routerLink: [
                            //                 this.commonService.getRoute({
                            //                     route: AirAppRoutes.Manager.USER_CONTROL,
                            //                     type: 'Manager',
                            //                 }),
                            //             ],
                            //         },
                            //         { label: 'Assign' },
                            //     ];
                            //     break;
                            // }
                            case AirAppRoutes.Manager.EVENTS_ROUTE: {
                                this.breadcrumbs = [{ label: 'Event manager' }];
                                break;
                            }

                            case  AirAppRoutes.UserFull.FLIGHT_EQUIVALENCY_MANAGER :{
                                this.breadcrumbs = [{ label: 'Flight Equivalency' }];
                                break;
                            }

                            // case AirAppRoutes.Manager.DATA_UPLOAD: {
                            //     this.selectButton = {
                            //         viewData: false,
                            //         viewHistory: false,
                            //     };
                            //     tempCtrl.history = true;
                            //     tempCtrl.data = true;
                            //     tempCtrl.visible = true;
                            //     this.breadcrumbs = [{ label: 'Upload' }];
                            //     break;
                            // }
                            // case AirAppRoutes.Manager.VIEW_DATA: {
                            //     this.selectButton = {
                            //         viewData: true,
                            //         viewHistory: false,
                            //     };
                            //     tempCtrl.history = true;
                            //     tempCtrl.data = true;
                            //     this.breadcrumbs = [
                            //         {
                            //             label: 'Upload',
                            //             routerLink: [
                            //                 this.commonService.getRoute({
                            //                     route: AirAppRoutes.Manager
                            //                         .DATA_UPLOAD,
                            //                     type: 'Manager',
                            //                 }),
                            //             ],
                            //         },
                            //         { label: 'View Data' },
                            //     ];
                            //     break;
                            // }

                            // case AirAppRoutes.Manager.VIEW_HISTORY: {
                            //     this.selectButton = {
                            //         viewData: false,
                            //         viewHistory: true,
                            //     };
                            //     tempCtrl.history = true;
                            //     tempCtrl.data = true;
                            //     this.breadcrumbs = [
                            //         {
                            //             label: 'Upload',
                            //             routerLink: [
                            //                 this.commonService.getRoute({
                            //                     route: AirAppRoutes.Manager
                            //                         .DATA_UPLOAD,
                            //                     type: 'Manager',
                            //                 }),
                            //             ],
                            //         },
                            //         { label: 'History' },
                            //     ];
                            //     break;
                            // }

                            default: {
                                
                                // if (this.hasCompany) { // TODO: add this condition from the companies api
                                tempCtrl.globalSearch = true;
                                tempCtrl.filter = true;
                                // }
                                this.breadcrumbs = [{ label: 'Home' }];                            
                                console.warn('Unhandled route:', this.currentNav.routeType);
                                break;
                            }
                        }
                        this.pageCtrl = tempCtrl;
                        // if (!this.pageCtrl.filter) {
                        //     // Hides the filter panel if Show filter button NOT in screen
                        //     this.filterService.changeFilterVisibility(false);
                        //     this.closeOverlay();
                        // }
                    }
                }
            ),
            this.filterService.$filterSelection.subscribe(
                (selectedFilters: ISelectedFilters) => {
                    if (!selectedFilters) {
                        this.filters = new SelectedFilters();
                    } else {
                        this.filters =
                            this.filterService.getIds(selectedFilters);
                    }
                }
            )
        );
    }

    closeOverlay() {
        const elem = document.getElementsByClassName('p-component-overlay')[0];
        if (elem) {
            var evObj = document.createEvent('Events');
            evObj.initEvent('click', false, false);
            elem.dispatchEvent(evObj);
        }
    }

    // keepMultiSelectOpen() {
    //   event.preventDefault();
    //   event.stopPropagation();
    // }

    ngOnInit(): void {
        this.subscription.add(
            this.navigationService.$currentNav.subscribe(
                (selectedNav: INavigationData) => {
                    if (selectedNav &&
                        !this.hasReloaded &&
                        !this.storageService.getItem('pageLoaded')) {

                        this.hasReloaded = true;
                        this.storageService.setItem('pageLoaded', 'true');
                     //   window.location.reload();
                    }
                    // ...existing navigation code...
                }
            )
        );
        this.filterService.getIsFilterSelectedStatus().subscribe((selected) => {
            this.isFilterSelected = selected;
        });

    }

    ngOnChanges() {
        switch (this.currentNav.routeType) {
            case AirAppRoutes.User.TRACKING_LIST_DETAILS:
                this.breadcrumbs = [
                    {
                        label: 'Tracking List',
                        routerLink: [
                            this.commonService.getRoute({
                                route: AirAppRoutes.User.TRACKING_LIST,
                                type: 'User',
                            }),
                        ],
                    },
                    { label: 'Tracking Details' },
                    { label: this.navData.label + ': ' + this.navData.value },
                ];
           //     console.log("Tracking List Details", this.breadcrumbs);
           //     console.log("Nav Data", this.navData);
                break;
            case AirAppRoutes.User.TRACKING_LIST_DETAILS_HOME:
                this.breadcrumbs = [
                    {
                        label: 'Home',
                        routerLink: [
                            this.commonService.getRoute({
                                route: AirAppRoutes.User.HOME,
                                type: 'User',
                            }),
                        ],
                    },
                    { label: 'Tracking Details' },
                    { label: this.navData.label + ': ' + this.navData.value },
                ];
                break;
            case AirAppRoutes.User.TRACKING_LIST_DETAILS_FAVORITE:
                this.breadcrumbs = [
                    {
                        label: 'Favorites',
                        routerLink: [
                            this.commonService.getRoute({
                                route: AirAppRoutes.User.FAVORITE,
                                type: 'User',
                            }),
                        ],
                    },
                    { label: 'Tracking Details' },
                    { label: this.navData.label + ': ' + this.navData.value },
                ];
                break;
            case AirAppRoutes.User.FLIGHT_EQUIVALENCY_MANAGER:
                this.breadcrumbs = [
                    {
                        label: 'Favorites',
                        routerLink: [
                            this.commonService.getRoute({
                                route: AirAppRoutes.User.FLIGHT_EQUIVALENCY_MANAGER,
                                type: 'User',
                            }),
                        ],
                    },
                    { label: 'Flight Equivalancy Management' },
                    { label: this.navData.label + ': ' + this.navData.value },
                ];
            default:
                break;
        }
    }

    customPeriodSelected(item: any) {
        switch (item.key) {
            case 0: {
                this.customPeriodListVisibility = true;
                break;
            }
            case 1: {
                this.endDate = null;
                this.startDate = null;
                this.exportTo('xls');
                this.customPeriodListVisibility = false;
                break;
            }

            default: {
                this.endDate = this.commonService.getCurrentDate();
                this.startDate = this.commonService.getMonthDifference(
                    item.key
                );
                this.exportTo('xls');
                this.customPeriodListVisibility = false;
                break;
            }
        }
    }

    choosedDate(event: any) { }

    selectedDate(event: any) {
        if (
            (this.startDate && this.endDate) ||
            (!this.startDate && !this.endDate)
        ) {
            if (event.startDate) {
                this.startDateActive = true;
                this.endDateActive = false;
                this.startDate = moment(event.startDate.$d).format(
                    'YYYY-MM-DD'
                );
                this.endDate = '';
            }
        }
        if (event.endDate) {
            this.startDateActive = false;
            this.endDateActive = true;
            this.endDate = moment(event.endDate.$d).format('YYYY-MM-DD');
        }
    }

    cancelClicked() {
        this.startDate = null;
        this.endDate = null;
        this.startDateActive = false;
        this.endDateActive = false;
        this.customPeriodListVisibility = false;
    }

    datesUpdated(ev: any) {
        this.startDate = moment(ev.startDate.$d).format('YYYY-MM-DD');
        this.endDate = moment(ev.endDate.$d).format('YYYY-MM-DD');
        this.exportTo('xls');
        this.customPeriodListVisibility = false;
    }

    // formating all input into (|) seprated values request
    formattedOriginRegion(): string {
        const selectedRegions =
            this.exceptionFilterFrom.get('originregion').value;
        if (Array.isArray(selectedRegions)) {
            return selectedRegions.map((region) => region).join('|');
        } else if (typeof selectedRegions === 'string') {
            return selectedRegions;
        }

        return '';
    }
    formattedTimeframe(): string {
        const selectedTimeframe =
            this.exceptionFilterFrom.get('timeframe').value;
        if (Array.isArray(selectedTimeframe)) {
            return selectedTimeframe.map((Timeframe) => Timeframe).join('|');
        } else if (typeof selectedTimeframe === 'string') {
            return selectedTimeframe;
        }

        return '';
    }
    formattedDestinationRegion(): string {
        const selectedRegions =
            this.exceptionFilterFrom.get('destinatinregion').value;
        if (Array.isArray(selectedRegions)) {
            return selectedRegions.map((region) => region).join('|');
        } else if (typeof selectedRegions === 'string') {
            return selectedRegions;
        }

        return '';
    }
    formattedCategory(): string {
        const selectedCategory = this.exceptionFilterFrom.get('category').value;
        if (Array.isArray(selectedCategory)) {
            return selectedCategory.map((Category) => Category).join('|');
        } else if (typeof selectedCategory === 'string') {
            return selectedCategory;
        }

        return '';
    }
    formattedServiceCode(): string {
        const selectedServiceCode =
            this.exceptionFilterFrom.get('ServiceCode').value;
        const mapServiceCode = [].concat(
            ...selectedServiceCode.map((value: number) =>
                this.mapServiceCode(value)
            )
        );
        if (Array.isArray(mapServiceCode)) {
            return mapServiceCode.map((ServiceCode) => ServiceCode).join('|');
        } else if (typeof selectedServiceCode === 'string') {
            return selectedServiceCode;
        }

        return '';
    }


    searchShipment(filters) {
        this.globalSearchValue = this.globalSearchValue.trim();
        this.storageService.updateRefreshClick(false, 'GlobalSearch');
        if (this.globalSearchValue && this.globalSearchValue.length >= 5) {
            const searchBody = {
                globalFilterRequest: this.selectedGlobalFilter,
                searchValue: this.globalSearchValue
            };

            if (this.globalSearchValue) {
                this.shipmentService.getShipmentSearch(searchBody).subscribe(
                    (response: any) => {
                 //       console.log('Response:', response);
                        //  console.log('Response:', response); 
                        if (response.status === 200) {
                            const shipmentIds = response.data.shipmentIds;
                            if (shipmentIds && shipmentIds.length === 1) {
                                const shipmentId = shipmentIds[0];
                                this.shipmentService.updateShipmentSearch(response.data);
                               // console.log('Shipment Id:', shipmentId);
                                this.commonService.navigateRoute({
                                    route: AirAppRoutes.User.TRACKING_LIST_DETAILS,
                                    type: 'User',
                                    routeData: shipmentId,
                                });
                            } else {
                                this.shipmentService.updateShipmentSearch(response.data.shipmentIds);
                                this.commonService.navigateRoute({
                                    route: AirAppRoutes.User.TRACKING_LIST,
                                    type: 'User',

                                });
                            }
                        }
                    },
                    (error: any) => {
                        //  console.error('Error:', error); 
                        if (error.status === 417) {

                            this.messageService.add({
                                key: 'emptyToster',
                                severity: 'error',
                                summary: 'Error Message',
                                life: 10000,
                                detail: error.error.data,
                            });
                        } else {
                            this.messageService.add({
                                key: 'noShipmentToaster',
                                severity: 'error',
                                summary: 'Error Message',
                                life: 10000,
                                detail: error.message,
                            });
                        }
                    }
                );
                this.globalSearchValue = '';
            }
        } else {
            this.messageService.add({
                key: 'noShipmentToaster',
                severity: 'error',
                summary: 'Error Message',
                life: 10000,
                detail: 'Search value must be at least 5 characters long.',
            });
            this.globalSearchValue = '';
        }
    }
    onNavButtonClicked(routeType: string) {
        switch (routeType) {
            case 'history':
                this.selectButton.viewData = false;
                this.selectButton.viewHistory = true;
                this.commonService.navigateRoute({
                    route:
                        AirAppRoutes.Manager.DATA_UPLOAD +
                        '/' +
                        AirAppRoutes.Manager.VIEW_HISTORY,
                    type: 'User',
                });
                break;
            case 'viewData':
                this.selectButton.viewData = true;
                this.selectButton.viewHistory = false;
                this.commonService.navigateRoute({
                    route:
                        AirAppRoutes.Manager.DATA_UPLOAD +
                        '/' +
                        AirAppRoutes.Manager.VIEW_DATA,
                    type: 'User',
                });
                break;
            default:
                break;
        }
    }

    exportTo(type: string) {
        switch (type) {
            case 'xls': {
                let filterData = { ...this.exceptionFilterFrom.value };
                filterData.originregion = this.formattedOriginRegion();
                filterData.destinatinregion = this.formattedDestinationRegion();
                filterData.timeframe = this.formattedTimeframe();
                filterData.ServiceCode = this.formattedServiceCode();
                filterData.category = this.formattedCategory();
                this.exceptionService.$exceptionTypeStatus
                    .subscribe(({ exceptionType, status }) => {
                        this.exceptionService
                            .downloadExceptionFile(
                                filterData,
                                exceptionType,
                                status,
                                this.startDate,
                                this.endDate,
                                this.companies
                            )
                            .subscribe((res: any) => {
                                const a = document.createElement('a');
                                a.href = window.URL.createObjectURL(res);
                                a.download = `ExceptionsList-${exceptionType}-${status}(${this.endDate}to${this.startDate}).xlsx`;
                                a.style.display = 'none';
                                document.body.appendChild(a);
                                a.click();
                                a.remove();
                            });
                    })
                    .unsubscribe();
                break;
            }
            case 'image': {
                break;
            }
            case 'pdf': {
                break;
            }
        }
    }

    openExport(event: MouseEvent) {
        this.showExport = !this.showExport;
        event.preventDefault();
        event.stopPropagation();
        return;
    }

    onFilterClick() {
        this.filterService.changeFilterVisibility(true);
    }

    // map service code with enum

    mapServiceCode(selectedValue: number): string[] {
        switch (selectedValue) {
            case 1:
                1;
                return [BdpServiceCode.IMPORT];
            case 2:
                2;
                return [BdpServiceCode.EXPORT];
            default:
                return [];
        }
    }

    onFilterSubmit() {
        let filterData = { ...this.exceptionFilterFrom.value };
        filterData.originregion = this.formattedOriginRegion();
        filterData.destinatinregion = this.formattedDestinationRegion();
        filterData.timeframe = this.formattedTimeframe();
        filterData.ServiceCode = this.formattedServiceCode();
        filterData.category = this.formattedCategory();
        this.onExceptionFilterSubmit.emit(filterData);
    }

    async loadExceptionFilterOptions() {
        this.exceptionCategories = [];
        this.exceptionTimeframes = [];
        this.exceptionSourceTypes = [];
        const regionData = await this.commonService.getRegion().toPromise();
        const dataArray = Array.isArray(regionData) ? regionData : [];
        if (dataArray && dataArray.length) {
            this.countryRegion = dataArray;
        }
        const exceptionOptions = await this.exceptionService
            .getExceptionFilterOptions()
            .toPromise();
        const exceptionOptionsdataArray = Array.isArray(exceptionOptions)
            ? exceptionOptions
            : [];
        if (exceptionOptionsdataArray && exceptionOptionsdataArray.length) {
            exceptionOptionsdataArray.forEach((option) => {
                let item = { label: option.name, value: option.type };
                switch (option.module) {
                    case 'CATEGORY':
                        this.exceptionCategories.push(item);
                        break;
                    case 'TIMEFRAME':
                        this.exceptionTimeframes.push(item);
                        break;
                    case 'SOURCE':
                        this.exceptionSourceTypes.push(item);
                        break;
                    case 'BDP SERVICE CODE':
                        this.bdpServiceCode.push(item);
                }
            });
            this.exceptionFilterFrom.patchValue({
                category: this.exceptionCategories.map((item) => item.value),
                timeframe: this.exceptionTimeframes.map((item) => item.value),
                source: [this.exceptionSourceTypes[0].value],
                originregion: this.countryRegion.map((item) => item.regionName),
                destinatinregion: this.countryRegion.map(
                    (item) => item.regionName
                ),
                ServiceCode: this.bdpServiceCode.map(
                    (item: { value: any }) => item.value
                ),
            });
            this.exceptionFilterFrom.valueChanges.subscribe((values: any) => {
                if (values) this.submitBtnDisabled = false;
            });

            this.onFilterSubmit();
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
